<template>
    <form v-if="!isLoggedIn" class="w-100" autocomplete="on" method="post" @submit.prevent="validateRegistration()" ref="registrationForm">
        <div class="row">
            <h2 class="col-sm-12 my-3">{{ $translate("MyWidgets::Template.b2bAccountDetails") }}</h2>
            <div class="col-sm-12">
                <div class="input-unit" data-validate="mail">
                    <input data-testing="mail-register" type="email" name="email" autocomplete="email" :id="'email'+_uid" v-model="username" data-autofocus>
                    <label :for="'email'+_uid">{{ $translate("Ceres::Template.regEmail") }}*</label>
                </div>
            </div>

            <div class="col-sm-6" v-if="!guestMode">
                <div class="input-unit" :class="{'no-bottom media-xs-d': modalElement}" data-validate="password" ref="passwordInput">
                    <popper v-cloak trigger="focus" placement="bottom" ref="passwordHint">
                        <template #handle>
                            <input data-testing="password-register" type="password" name="password" autocomplete="new-password" :id="'new-password-' + _uid" v-model="password">
                        </template>

                        <template #title>
                            <div>
                                {{ $translate("Ceres::Template.regPasswordHintTitle") }}
                            </div>
                        </template> 

                        <template #content>
                            <ul class="pl-3">
                                <li>{{ $translate("Ceres::Template.regPasswordHintLength") }}</li>
                                <li>{{ $translate("Ceres::Template.regPasswordHintDigit") }}</li>
                                <li>{{ $translate("Ceres::Template.regPasswordHintChar") }}</li>
                            </ul>
                        </template>
                    </popper>

                    <label :for="'new-password-' + _uid">{{ $translate("Ceres::Template.regPassword") }}*</label>
                </div>
            </div>

            <div class="col-sm-6 input-unit-group" v-if="!guestMode">
                <div class="input-unit" :class="{'no-bottom': modalElement}" data-validate="ref">
                    <input type="password" name="password-repeat" autocomplete="new-password" :id="'new-password-repeat-' + _uid" v-model="passwordRepeat" :data-validate-ref="'#new-password-' + _uid" data-testing="repeat-password-register">
                    <label :for="'new-password-repeat-' + _uid">{{ $translate("Ceres::Template.regRepeatPassword") }}*</label>
                </div>
            </div>

            <input class="honey" type="text" name="username" autocomplete="new-password" tabindex="-1" v-model="honeypot">

            <h2 class="col-sm-12 my-3">{{ $translate("MyWidgets::Template.b2bCompanyData") }}</h2>
            <div class="col-12">
                <address-input-group
                    template="#vue-address-input-group"
                    v-if="!isSimpleRegistration"
                    address-type="1"
                    :value="billingAddress"
                    @input="setAddressDataField($event)"
                    :optional-address-fields="shownFields"
                    :required-address-fields="requiredFields"
                    :default-salutation="defaultSalutation">
                    <template #custom-address-fields>
                        <slot name="custom-address-fields"></slot>
                    </template>
                </address-input-group>
            </div>

            <div class="col-12" v-if="enableConfirmingPrivacyPolicy">
                <accept-privacy-policy-check
                        class="mt-3 mb-0"
                        v-model="privacyPolicyAccepted"
                        @input="privacyPolicyValueChanged($event)"
                        :show-error="privacyPolicyShowError">
                </accept-privacy-policy-check>
            </div>
        </div>
        <div class="border-top mt-2 text-right">
            
            <button :disabled="isDisabled" class="btn btn-appearance btn-primary btn-medium mt-3" :class="buttonSizeClass" data-testing="register-submit">
                {{ $translate("Ceres::Template.regRegister") }}
                <icon icon="user-plus" class="default-float" :loading="isDisabled"></icon>
            </button>
        </div>

        <recaptcha v-if="!!googleRecaptchaApiKey && (modalShown || !isSimpleRegistration)"></recaptcha>
    </form>
</template>

<script>

// we replaced ./ with Ceres/components/itemList/  where Ceres is alias of  Ceres\resources\js\src\app
import registration from "Ceres/components/customer/Registration.vue";
import { mapGetters } from "vuex";
// import ApiService from "Ceres/services/ApiService";
// import NotificationService from "Ceres/services/NotificationService";

export default {

    name: "b2bregistration",
    extends: registration,

    computed: {
        ...mapGetters([
           "isLoggedIn"
        ])
    },

    mounted()
    {
        document.addEventListener("onSignUpSuccess", event =>
        {
            /* Send an email to inform us for the new request */
            /*
                const formOptions = {
                    recipient: "admin@irritop.com",
                    subject: "New B2B registration Request",
                    cc: [],
                    bcc: [],
                    replyTo: {
                        mail: null,
                        name: ""
                    }
                };

            ApiService.post(
                "/rest/io/customer/contact/mail",
                {
                    data:       "New B2B request: Customer ID: ",
                    recipient:  formOptions.recipient,
                    subject:    formOptions.subject || "",
                    cc:         formOptions.cc,
                    bcc:        formOptions.bcc,
                    replyTo:    formOptions.replyTo,
                    recaptchaToken: event.detail.recaptcha
                }
            )
                .done(response =>
                {
                    NotificationService.success(
                        this.$translate("Ceres::Template.contactSendSuccess")
                    ).closeAfter(3000);
                })
                .fail(response =>
                {
                    resetRecaptcha(recaptchaToken);
                    disableForm(event.target, false);
                    NotificationService.error(TranslationService.translate("Ceres::Template.contactSendFail"));
                });
                */
            /* Send an email to inform us for the new request */
        });

    },

    methods: {


        /**
         * Handle the user object which is send to the server
         * @returns {{contact: {referrerId: number, typeId: number, options: {typeId: {typeId: number, subTypeId: number, value: *, priority: number}}}, honeypot: string}|{contact: {referrerId: number, typeId: number, password: *, options: {typeId: {typeId: number, subTypeId: number, value: *, priority: number}}}, honeypot: string}}
         */
        getUserObject()
        {
            const userObject =
                {
                    contact: {
                        referrerId: 1,
                        typeId    : 7,
                        options   : {
                            typeId: {
                                typeId   : 2,
                                subTypeId: 4,
                                value    : this.username,
                                priority : 0
                            }
                        }
                    },
                    honeypot: this.honeypot
                };

            if (!this.guestMode)
            {
                userObject.contact.password = this.password;
            }

            if (!this.isSimpleRegistration)
            {
                userObject.billingAddress = this.billingAddress;
            }

            return userObject;
        }

    }
}
</script>
